// services/api.js

const BASE_URL = 'https://backend.maamaas.com/promotions/api';

// const BASE_URL = 'http://testing.maamaas.com:8080/promotions/api';

class ApiService {
  async getScreenData(deviceId, password) {
    try {
      const url = `${BASE_URL}/digital/screen-data?deviceId=${encodeURIComponent(deviceId)}&password=${encodeURIComponent(password)}`;
      //console.log('Fetching URL:', url);
      
      const response = await fetch(url);
      
      //console.log('Response status:', response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        //console.log('Error response:', errorText);
        throw new Error(errorText || 'Invalid device ID or password');
      }
      
      const data = await response.json();
      //console.log('Response data:', data);
      return data;
      
    } catch (error) {
      console.error('API Error - getScreenData:', error);
      throw error;
    }
  }

  async updateCampaignActive(campaignId, deviceId, active = true) {
    try {
      const url = `${BASE_URL}/screen/update-screen-data?campaignId=${campaignId}&deviceId=${deviceId}`;
      //console.log('Updating campaign URL:', url);
      
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          active: active
        })
      });

      //console.log('Update response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        //console.log('Update error response:', errorText);
        throw new Error(errorText || 'Failed to update campaign');
      }

      // Check if response has content before parsing JSON
      const text = await response.text();
      //console.log('Update response text:', text);
      
      // Return empty object if no content, otherwise parse JSON
      return text ? JSON.parse(text) : { success: true };
      
    } catch (error) {
      console.error('API Error - updateCampaignActive:', error);
      throw error;
    }
  }

  formatErrorMessage(error) {
    if (error.message.includes('Failed to fetch')) {
      return 'Network error. Please check your connection.';
    }
    return error.message || 'An unexpected error occurred.';
  }

  generatePlaylist(campaignList) {
    if (!campaignList || campaignList.length === 0) return [];

    const highPriority = campaignList.filter(c => c.priority === "HIGH");
    const lowPriority = campaignList.filter(c => c.priority === "LOW");
    
    const playlist = [];

    if (highPriority.length === 0) {
      return [...lowPriority];
    }

    if (lowPriority.length === 0) {
      return [...highPriority];
    }

    for (let i = 0; i < lowPriority.length; i++) {
      playlist.push(...highPriority);
      playlist.push(lowPriority[i]);
    }

    playlist.push(...highPriority);
    return playlist;
  }
}

const apiService = new ApiService();
export default apiService;